export const imgSplash = require("../assets/logo.png");
